export function getNextSelectableIndex<TItem>(
  startIndex: number,
  items: TItem[],
  isOptionDisabled: (item: TItem) => boolean,
): number {
  const selectableItems = items.filter((item) => !isOptionDisabled(item));

  if (!selectableItems.length) {
    return -1;
  }

  for (let index = startIndex + 1; index < items.length; index += 1) {
    if (!isOptionDisabled(items[index])) {
      return index;
    }
  }

  return getNextSelectableIndex(-1, items, isOptionDisabled);
}

export function getPreviousSelectableIndex<TItem>(
  startIndex: number,
  items: TItem[],
  isOptionDisabled: (item: TItem) => boolean,
): number {
  const selectableItems = items.filter((item) => !isOptionDisabled(item));

  if (!selectableItems.length) {
    return -1;
  }

  for (let index = startIndex - 1; index >= 0; index -= 1) {
    if (!isOptionDisabled(items[index])) {
      return index;
    }
  }

  return getPreviousSelectableIndex(items.length, items, isOptionDisabled);
}
